import { Select as BaseSelect } from '@kvdbil/components';
import { SelectProps as BaseSelectProps } from '@kvdbil/components/types/components/Select';
import React from 'react';
import {
  Control,
  Controller,
  FieldValues,
  Path,
  PathValue
} from 'react-hook-form';
import { ControllerRules } from '~/App/shared/interfaces/ControllerRules';

export type SelectProps<FormState extends FieldValues> = Omit<
  BaseSelectProps,
  'onChange'
> & {
  control: Control<FormState>;
  name: Path<FormState>;
  rules?: ControllerRules;
  defaultValue?: PathValue<FormState, Path<FormState>>;
};

const Select = React.forwardRef((props: BaseSelectProps, ref) => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore next-line
  <BaseSelect {...props} forwardRef={ref} />
));

const SelectWithControl = <FormState extends FieldValues>(
  props: SelectProps<FormState>
) => {
  const { helperText, ...restProps } = props;
  return (
    <Controller<FormState>
      {...restProps}
      render={({ field, fieldState }) => {
        const hasError = Boolean(fieldState.error);
        return (
          <Select
            instanceId={restProps.instanceId ?? `field-${restProps.name}`}
            {...restProps}
            {...field}
            value={field.value}
            hasError={hasError}
            helperText={hasError ? fieldState?.error?.message : helperText}
          />
        );
      }}
    />
  );
};

export default SelectWithControl;
